import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/contatti/Contatti.vue'),
		meta: {
			title: 'contatti',
			acl: 'section.contatti'
		}
	}
];

export default routes;